export const translations = {
  de: {
    common: {
      appName: "qrmenu-pro.com",
      tagline: "Digitale Speisekarten in Minuten",
      home: "Startseite",
      pricing: "Preise",
      login: "Anmelden",
      register: "Registrieren",
      logout: "Abmelden",
      dashboard: "Dashboard",
      settings: "Einstellungen",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      add: "Hinzufügen",
      back: "Zurück",
      next: "Weiter",
      preview: "Vorschau",
      download: "Herunterladen",
      copy: "Kopieren",
      copied: "Kopiert!",
      yes: "Ja",
      no: "Nein",
      loading: "Lädt...",
      error: "Fehler",
      success: "Erfolg",
      search: "Suchen",
      filter: "Filter",
      all: "Alle",
      language: "Sprache",
      theme: "Design",
      darkMode: "Dunkler Modus",
      lightMode: "Heller Modus",
    },
    landing: {
      heroBadge: "Neu — Mehrsprachige Plattform",
      heroTitle1: "Digitale QR-Menüs für",
      heroTitle2: "moderne Gastronomie",
      heroSubtitle: "Erstelle in wenigen Minuten ein vollständig anpassbares digitales Menü für dein Restaurant, Café oder deine Bar — ganz ohne Programmierkenntnisse.",
      ctaPrimary: "Kostenlos starten",
      ctaSecondary: "Demo ansehen",
      featuresTitle: "Alles, was deine Gäste begeistert",
      featuresSubtitle: "Premium-Funktionen für jede Größe von Gastronomiebetrieb",
      f1Title: "Mehrere Filialen",
      f1Desc: "Verwalte unbegrenzt viele Restaurants und Filialen aus einem Dashboard.",
      f2Title: "Live-Vorschau",
      f2Desc: "Sieh sofort, wie dein Menü auf dem Smartphone deiner Gäste aussieht.",
      f3Title: "Eigenes Branding",
      f3Desc: "Farben, Schriftarten, Logo und Layout — alles passt zu deiner Marke.",
      f4Title: "QR-Code Export",
      f4Desc: "Lade deinen QR-Code als PNG oder druckfertiges PDF herunter.",
      f5Title: "Statistiken",
      f5Desc: "Erfahre, welche Gerichte deine Gäste am meisten lieben.",
      f6Title: "3 Sprachen",
      f6Desc: "Deutsch, Türkisch, Englisch — wechsel mit einem Klick.",
      ctaTitle: "Bereit für deine digitale Speisekarte?",
      ctaDesc: "Starte heute kostenlos. Keine Kreditkarte erforderlich.",
    },
    pricing: {
      title: "Wähle deinen Plan",
      subtitle: "Faire Preise. Jederzeit kündbar. Wachse mit uns.",
      perMonth: "/Monat",
      mostPopular: "Beliebt",
      free: "Free",
      starter: "Starter",
      pro: "Pro",
      agency: "Agency",
      choosePlan: "Plan wählen",
      currentPlan: "Aktueller Plan",
    },
    auth: {
      loginTitle: "Willkommen zurück",
      loginSubtitle: "Melde dich an, um dein Dashboard zu öffnen",
      registerTitle: "Account erstellen",
      registerSubtitle: "Starte in 30 Sekunden — kostenlos",
      email: "E-Mail",
      password: "Passwort",
      name: "Name",
      forgot: "Passwort vergessen?",
      noAccount: "Noch kein Konto?",
      hasAccount: "Bereits registriert?",
      signIn: "Einloggen",
      signUp: "Registrieren",
      forgotTitle: "Passwort vergessen?",
      forgotSubtitle: "Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen deines Passworts.",
      sendResetLink: "Link senden",
      backToLogin: "Zurück zum Login",
      forgotSuccessTitle: "Prüfe dein Postfach",
      forgotSuccessBody: "Wenn ein Konto mit dieser E-Mail-Adresse existiert, haben wir einen Link zum Zurücksetzen des Passworts gesendet. Der Link ist 30 Minuten gültig.",
      resetTitle: "Neues Passwort festlegen",
      resetSubtitle: "Wähle ein sicheres neues Passwort für dein Konto.",
      newPassword: "Neues Passwort",
      confirmPassword: "Passwort bestätigen",
      resetCta: "Passwort speichern",
      resetSuccessTitle: "Passwort aktualisiert",
      resetSuccessBody: "Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.",
      goToLogin: "Zum Login",
      passwordsDontMatch: "Die Passwörter stimmen nicht überein.",
      passwordTooShort: "Das Passwort muss mindestens 8 Zeichen lang sein.",
      missingToken: "Der Reset-Link ist ungültig. Bitte fordere einen neuen an.",
    },
    dashboard: {
      welcome: "Willkommen",
      yourRestaurants: "Deine Restaurants",
      addRestaurant: "Restaurant hinzufügen",
      noRestaurants: "Noch keine Restaurants — leg gleich los!",
      totalViews: "Aufrufe gesamt",
      totalScans: "QR-Scans",
      totalItems: "Menü-Einträge",
      menuBuilder: "Menü-Builder",
      themeCustomizer: "Theme-Anpassung",
      qrCode: "QR-Code",
      statistics: "Statistik",
      adminPanel: "Admin",
    },
    restaurant: {
      newRestaurant: "Neues Restaurant",
      restaurantName: "Restaurant-Name",
      description: "Beschreibung",
      currency: "Währung",
      logo: "Logo",
      coverImage: "Titelbild",
      address: "Adresse",
      phone: "Telefon",
      website: "Website",
      uploadLogo: "Logo hochladen",
      uploadCover: "Titelbild hochladen",
    },
    menu: {
      categories: "Kategorien",
      addCategory: "Kategorie hinzufügen",
      categoryName: "Kategorie-Name",
      items: "Einträge",
      addItem: "Eintrag hinzufügen",
      itemName: "Name",
      itemDesc: "Beschreibung",
      itemPrice: "Preis",
      itemImage: "Bild",
      allergens: "Allergene",
      ingredients: "Zutaten",
      tags: "Tags",
      available: "Verfügbar",
      unavailable: "Nicht verfügbar",
      tagPopular: "Beliebt",
      tagNew: "Neu",
      tagOffer: "Angebot",
      tagVegan: "Vegan",
      tagSpicy: "Scharf",
      separateByComma: "Mit Komma trennen",
      customLabels: "Eigene Labels",
      customLabelsHint: "Eigene Badges, die auf der Produktkarte angezeigt werden",
      addLabel: "Label hinzufügen",
      labelText: "Text (z. B. Menü möglich +4,50 €)",
      labelColor: "Farbe",
      removeLabel: "Entfernen",
      editCategory: "Kategorie bearbeiten",
      infoBox: "Info-Box",
      infoBoxHint: "Wird oben in der Kategorie und in 'Alle' direkt vor den Produkten angezeigt",
      infoTitle: "Titel",
      infoText: "Beschreibung (Zeilenumbrüche erlaubt)",
      infoIcon: "Icon (Emoji, optional)",
    },
    theme: {
      title: "Theme anpassen",
      primaryColor: "Hauptfarbe",
      accentColor: "Akzentfarbe",
      backgroundColor: "Hintergrund",
      textColor: "Textfarbe",
      fontFamily: "Schriftart",
      layout: "Layout",
      buttonStyle: "Buttons",
      grid: "Gitter",
      list: "Liste",
      cards: "Karten",
      rounded: "Abgerundet",
      sharp: "Eckig",
      pill: "Pille",
    },
    qr: {
      title: "QR-Code für dein Menü",
      subtitle: "Drucke den QR-Code aus oder zeige ihn auf dem Tisch — Gäste scannen und sehen sofort dein Menü.",
      downloadPng: "PNG herunterladen",
      downloadPdf: "PDF herunterladen",
      publicUrl: "Öffentliche URL",
    },
    stats: {
      title: "Statistiken",
      last7days: "Letzte 7 Tage",
      topItems: "Beliebteste Produkte",
      noData: "Noch keine Daten",
    },
    publicMenu: {
      searchPlaceholder: "Gericht suchen...",
      poweredBy: "Erstellt mit",
      contains: "Enthält",
    },
    cart: {
      addToCart: "Hinzufügen",
      cart: "Warenkorb",
      empty: "Dein Warenkorb ist leer",
      qty: "Menge",
      note: "Notiz",
      itemNotePlaceholder: "z. B. ohne Zwiebeln",
      orderNote: "Bestellnotiz (optional)",
      orderNotePlaceholder: "z. B. Bitte extra scharf",
      variant: "Variante",
      extras: "Extras",
      subtotal: "Zwischensumme",
      total: "Gesamt",
      placeOrder: "Bestellung aufgeben",
      sending: "Wird gesendet…",
      orderSent: "Bestellung gesendet!",
      orderSentDetail: "Der Kellner wurde benachrichtigt.",
      tableRequired: "Bitte scanne den QR-Code deines Tisches.",
      tableNumber: "Tisch",
      remove: "Entfernen",
      close: "Schließen",
      chooseOptions: "Optionen wählen",
      required: "Erforderlich",
    },
    orders: {
      title: "Bestellungen",
      empty: "Noch keine Bestellungen",
      open: "Offen",
      preparing: "In Zubereitung",
      served: "Serviert",
      paid: "Bezahlt",
      canceled: "Storniert",
      all: "Alle",
      table: "Tisch",
      items: "Artikel",
      total: "Total",
      time: "Zeit",
      updateStatus: "Status ändern",
      markPreparing: "In Zubereitung",
      markServed: "Als serviert markieren",
      markPaid: "Als bezahlt markieren",
      cancel: "Stornieren",
      openBill: "Offene Rechnung",
    },
    menuBuilder: {
      variants: "Varianten (Größen)",
      variantsHint: "z. B. Klein, Normal, Groß — Preis wird zum Grundpreis addiert",
      addVariant: "Variante hinzufügen",
      variantName: "Name (z. B. L)",
      variantDelta: "Aufpreis",
      extras: "Extras",
      extrasHint: "z. B. Extra Käse, Bacon — feste Zusatzpreise",
      addExtra: "Extra hinzufügen",
      extraName: "Name (z. B. extra Käse)",
      extraPrice: "Preis",
    },
    admin: {
      title: "Admin-Bereich",
      users: "Benutzer",
      changePlan: "Plan ändern",
      totalUsers: "Benutzer",
      totalRestaurants: "Restaurants",
    },
  },
  en: {
    common: {
      appName: "qrmenu-pro.com",
      tagline: "Digital menus in minutes",
      home: "Home",
      pricing: "Pricing",
      login: "Log in",
      register: "Sign up",
      logout: "Log out",
      dashboard: "Dashboard",
      settings: "Settings",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      back: "Back",
      next: "Next",
      preview: "Preview",
      download: "Download",
      copy: "Copy",
      copied: "Copied!",
      yes: "Yes",
      no: "No",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      search: "Search",
      filter: "Filter",
      all: "All",
      language: "Language",
      theme: "Theme",
      darkMode: "Dark mode",
      lightMode: "Light mode",
    },
    landing: {
      heroBadge: "New — Multilingual platform",
      heroTitle1: "Digital QR menus for",
      heroTitle2: "modern hospitality",
      heroSubtitle: "Create a fully customizable digital menu for your restaurant, café or bar in minutes — no coding required.",
      ctaPrimary: "Start for free",
      ctaSecondary: "View demo",
      featuresTitle: "Everything your guests will love",
      featuresSubtitle: "Premium features for any hospitality business",
      f1Title: "Multiple locations",
      f1Desc: "Manage unlimited restaurants and locations from one dashboard.",
      f2Title: "Live preview",
      f2Desc: "See exactly how your menu looks on your guests' phones.",
      f3Title: "Custom branding",
      f3Desc: "Colors, fonts, logo and layout — everything matches your brand.",
      f4Title: "QR code export",
      f4Desc: "Download your QR as PNG or print-ready PDF.",
      f5Title: "Statistics",
      f5Desc: "Know which dishes your guests love the most.",
      f6Title: "3 languages",
      f6Desc: "German, Turkish, English — switch with one click.",
      ctaTitle: "Ready for your digital menu?",
      ctaDesc: "Start today for free. No credit card required.",
    },
    pricing: {
      title: "Choose your plan",
      subtitle: "Fair pricing. Cancel anytime. Grow with us.",
      perMonth: "/month",
      mostPopular: "Popular",
      free: "Free",
      starter: "Starter",
      pro: "Pro",
      agency: "Agency",
      choosePlan: "Choose plan",
      currentPlan: "Current plan",
    },
    auth: {
      loginTitle: "Welcome back",
      loginSubtitle: "Sign in to access your dashboard",
      registerTitle: "Create account",
      registerSubtitle: "Get started in 30 seconds — free",
      email: "Email",
      password: "Password",
      name: "Name",
      forgot: "Forgot password?",
      noAccount: "Don't have an account?",
      hasAccount: "Already registered?",
      signIn: "Sign in",
      signUp: "Sign up",
      forgotTitle: "Forgot your password?",
      forgotSubtitle: "Enter your email address and we'll send you a link to reset your password.",
      sendResetLink: "Send reset link",
      backToLogin: "Back to login",
      forgotSuccessTitle: "Check your inbox",
      forgotSuccessBody: "If an account with this email exists, we've sent you a password reset link. The link is valid for 30 minutes.",
      resetTitle: "Set a new password",
      resetSubtitle: "Choose a strong new password for your account.",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      resetCta: "Save password",
      resetSuccessTitle: "Password updated",
      resetSuccessBody: "Your password has been changed successfully. You can now sign in.",
      goToLogin: "Go to login",
      passwordsDontMatch: "Passwords don't match.",
      passwordTooShort: "Password must be at least 8 characters.",
      missingToken: "The reset link is invalid. Please request a new one.",
    },
    dashboard: {
      welcome: "Welcome",
      yourRestaurants: "Your restaurants",
      addRestaurant: "Add restaurant",
      noRestaurants: "No restaurants yet — let's create one!",
      totalViews: "Total views",
      totalScans: "QR scans",
      totalItems: "Menu items",
      menuBuilder: "Menu builder",
      themeCustomizer: "Theme customizer",
      qrCode: "QR code",
      statistics: "Statistics",
      adminPanel: "Admin",
    },
    restaurant: {
      newRestaurant: "New restaurant",
      restaurantName: "Restaurant name",
      description: "Description",
      currency: "Currency",
      logo: "Logo",
      coverImage: "Cover image",
      address: "Address",
      phone: "Phone",
      website: "Website",
      uploadLogo: "Upload logo",
      uploadCover: "Upload cover",
    },
    menu: {
      categories: "Categories",
      addCategory: "Add category",
      categoryName: "Category name",
      items: "Items",
      addItem: "Add item",
      itemName: "Name",
      itemDesc: "Description",
      itemPrice: "Price",
      itemImage: "Image",
      allergens: "Allergens",
      ingredients: "Ingredients",
      tags: "Tags",
      available: "Available",
      unavailable: "Unavailable",
      tagPopular: "Popular",
      tagNew: "New",
      tagOffer: "Offer",
      tagVegan: "Vegan",
      tagSpicy: "Spicy",
      separateByComma: "Comma-separated",
      customLabels: "Custom Labels",
      customLabelsHint: "Custom badges shown on the product card",
      addLabel: "Add label",
      labelText: "Text (e.g. Menu option +4.50 €)",
      labelColor: "Color",
      removeLabel: "Remove",
      editCategory: "Edit category",
      infoBox: "Info Box",
      infoBoxHint: "Shown at the top of the category and right above its products in 'All' view",
      infoTitle: "Title",
      infoText: "Description (line breaks supported)",
      infoIcon: "Icon (emoji, optional)",
    },
    theme: {
      title: "Customize theme",
      primaryColor: "Primary color",
      accentColor: "Accent color",
      backgroundColor: "Background",
      textColor: "Text color",
      fontFamily: "Font",
      layout: "Layout",
      buttonStyle: "Buttons",
      grid: "Grid",
      list: "List",
      cards: "Cards",
      rounded: "Rounded",
      sharp: "Sharp",
      pill: "Pill",
    },
    qr: {
      title: "QR code for your menu",
      subtitle: "Print the QR code or display it on tables — guests scan and see your menu instantly.",
      downloadPng: "Download PNG",
      downloadPdf: "Download PDF",
      publicUrl: "Public URL",
    },
    stats: {
      title: "Statistics",
      last7days: "Last 7 days",
      topItems: "Top items",
      noData: "No data yet",
    },
    publicMenu: {
      searchPlaceholder: "Search dishes...",
      poweredBy: "Powered by",
      contains: "Contains",
    },
    cart: {
      addToCart: "Add",
      cart: "Cart",
      empty: "Your cart is empty",
      qty: "Qty",
      note: "Note",
      itemNotePlaceholder: "e.g. no onions",
      orderNote: "Order note (optional)",
      orderNotePlaceholder: "e.g. extra spicy please",
      variant: "Variant",
      extras: "Extras",
      subtotal: "Subtotal",
      total: "Total",
      placeOrder: "Place order",
      sending: "Sending…",
      orderSent: "Order sent!",
      orderSentDetail: "The waiter has been notified.",
      tableRequired: "Please scan the QR code at your table.",
      tableNumber: "Table",
      remove: "Remove",
      close: "Close",
      chooseOptions: "Choose options",
      required: "Required",
    },
    orders: {
      title: "Orders",
      empty: "No orders yet",
      open: "Open",
      preparing: "Preparing",
      served: "Served",
      paid: "Paid",
      canceled: "Canceled",
      all: "All",
      table: "Table",
      items: "Items",
      total: "Total",
      time: "Time",
      updateStatus: "Update status",
      markPreparing: "Preparing",
      markServed: "Mark served",
      markPaid: "Mark paid",
      cancel: "Cancel",
      openBill: "Open bill",
    },
    menuBuilder: {
      variants: "Variants (sizes)",
      variantsHint: "e.g. Small, Medium, Large — price adds to the base",
      addVariant: "Add variant",
      variantName: "Name (e.g. L)",
      variantDelta: "Price delta",
      extras: "Extras",
      extrasHint: "e.g. Extra cheese, Bacon — fixed add-on prices",
      addExtra: "Add extra",
      extraName: "Name (e.g. extra cheese)",
      extraPrice: "Price",
    },
    admin: {
      title: "Admin panel",
      users: "Users",
      changePlan: "Change plan",
      totalUsers: "Users",
      totalRestaurants: "Restaurants",
    },
  },
  tr: {
    common: {
      appName: "qrmenu-pro.com",
      tagline: "Dakikalar içinde dijital menü",
      home: "Ana Sayfa",
      pricing: "Fiyatlar",
      login: "Giriş Yap",
      register: "Kayıt Ol",
      logout: "Çıkış",
      dashboard: "Panel",
      settings: "Ayarlar",
      save: "Kaydet",
      cancel: "İptal",
      delete: "Sil",
      edit: "Düzenle",
      add: "Ekle",
      back: "Geri",
      next: "İleri",
      preview: "Önizleme",
      download: "İndir",
      copy: "Kopyala",
      copied: "Kopyalandı!",
      yes: "Evet",
      no: "Hayır",
      loading: "Yükleniyor...",
      error: "Hata",
      success: "Başarılı",
      search: "Ara",
      filter: "Filtre",
      all: "Tümü",
      language: "Dil",
      theme: "Tema",
      darkMode: "Karanlık mod",
      lightMode: "Aydınlık mod",
    },
    landing: {
      heroBadge: "Yeni — Çok dilli platform",
      heroTitle1: "Modern restoranlar için",
      heroTitle2: "dijital QR menüler",
      heroSubtitle: "Restoranınız, kafeniz veya barınız için dakikalar içinde tamamen özelleştirilebilir bir dijital menü oluşturun — kod yazmaya gerek yok.",
      ctaPrimary: "Ücretsiz başla",
      ctaSecondary: "Demoyu gör",
      featuresTitle: "Misafirlerinizin seveceği her şey",
      featuresSubtitle: "Her büyüklükteki işletme için premium özellikler",
      f1Title: "Birden çok şube",
      f1Desc: "Tek panelden sınırsız restoran ve şube yönetin.",
      f2Title: "Canlı önizleme",
      f2Desc: "Menünüzün misafirlerinizin telefonunda nasıl göründüğünü anında görün.",
      f3Title: "Özel marka",
      f3Desc: "Renkler, yazı tipleri, logo ve düzen — markanıza uyar.",
      f4Title: "QR kod indirme",
      f4Desc: "QR kodunuzu PNG veya baskıya hazır PDF olarak indirin.",
      f5Title: "İstatistikler",
      f5Desc: "Misafirlerinizin en çok hangi yemekleri sevdiğini öğrenin.",
      f6Title: "3 dil",
      f6Desc: "Almanca, Türkçe, İngilizce — tek tıkla değiştirin.",
      ctaTitle: "Dijital menünüze hazır mısınız?",
      ctaDesc: "Bugün ücretsiz başlayın. Kredi kartı gerekmez.",
    },
    pricing: {
      title: "Planınızı seçin",
      subtitle: "Adil fiyatlar. İstediğiniz zaman iptal edin. Bizimle büyüyün.",
      perMonth: "/ay",
      mostPopular: "Popüler",
      free: "Ücretsiz",
      starter: "Başlangıç",
      pro: "Pro",
      agency: "Ajans",
      choosePlan: "Planı seç",
      currentPlan: "Mevcut plan",
    },
    auth: {
      loginTitle: "Tekrar hoş geldiniz",
      loginSubtitle: "Panele erişmek için giriş yapın",
      registerTitle: "Hesap oluştur",
      registerSubtitle: "30 saniyede başlayın — ücretsiz",
      email: "E-posta",
      password: "Şifre",
      name: "İsim",
      forgot: "Şifrenizi mi unuttunuz?",
      noAccount: "Hesabınız yok mu?",
      hasAccount: "Zaten kayıtlı mısınız?",
      signIn: "Giriş yap",
      signUp: "Kayıt ol",
    },
    dashboard: {
      welcome: "Hoş geldiniz",
      yourRestaurants: "Restoranlarınız",
      addRestaurant: "Restoran ekle",
      noRestaurants: "Henüz restoran yok — şimdi oluşturalım!",
      totalViews: "Toplam görüntüleme",
      totalScans: "QR taramaları",
      totalItems: "Menü öğeleri",
      menuBuilder: "Menü oluşturucu",
      themeCustomizer: "Tema özelleştirici",
      qrCode: "QR kod",
      statistics: "İstatistikler",
      adminPanel: "Yönetici",
    },
    restaurant: {
      newRestaurant: "Yeni restoran",
      restaurantName: "Restoran adı",
      description: "Açıklama",
      currency: "Para birimi",
      logo: "Logo",
      coverImage: "Kapak resmi",
      address: "Adres",
      phone: "Telefon",
      website: "Web sitesi",
      uploadLogo: "Logo yükle",
      uploadCover: "Kapak yükle",
    },
    menu: {
      categories: "Kategoriler",
      addCategory: "Kategori ekle",
      categoryName: "Kategori adı",
      items: "Öğeler",
      addItem: "Öğe ekle",
      itemName: "İsim",
      itemDesc: "Açıklama",
      itemPrice: "Fiyat",
      itemImage: "Resim",
      allergens: "Alerjenler",
      ingredients: "Malzemeler",
      tags: "Etiketler",
      available: "Mevcut",
      unavailable: "Mevcut değil",
      tagPopular: "Popüler",
      tagNew: "Yeni",
      tagOffer: "Fırsat",
      tagVegan: "Vegan",
      tagSpicy: "Acılı",
      separateByComma: "Virgülle ayırın",
      customLabels: "Özel Etiketler",
      customLabelsHint: "Ürün kartında görünen özel rozetler",
      addLabel: "Etiket ekle",
      labelText: "Metin (örn. Menü olabilir +4,50 €)",
      labelColor: "Renk",
      removeLabel: "Kaldır",
    },
    theme: {
      title: "Temayı özelleştir",
      primaryColor: "Ana renk",
      accentColor: "Vurgu rengi",
      backgroundColor: "Arka plan",
      textColor: "Yazı rengi",
      fontFamily: "Yazı tipi",
      layout: "Düzen",
      buttonStyle: "Butonlar",
      grid: "Izgara",
      list: "Liste",
      cards: "Kartlar",
      rounded: "Yuvarlak",
      sharp: "Keskin",
      pill: "Hap",
    },
    qr: {
      title: "Menünüz için QR kod",
      subtitle: "QR kodu yazdırın veya masada gösterin — misafirler tarayıp menünüzü anında görür.",
      downloadPng: "PNG indir",
      downloadPdf: "PDF indir",
      publicUrl: "Genel URL",
    },
    stats: {
      title: "İstatistikler",
      last7days: "Son 7 gün",
      topItems: "En popüler öğeler",
      noData: "Henüz veri yok",
    },
    publicMenu: {
      searchPlaceholder: "Yemek ara...",
      poweredBy: "Hazırlayan",
      contains: "İçerir",
    },
    cart: {
      addToCart: "Ekle",
      cart: "Sepet",
      empty: "Sepetiniz boş",
      qty: "Adet",
      note: "Not",
      itemNotePlaceholder: "örn. soğansız",
      orderNote: "Sipariş notu (isteğe bağlı)",
      orderNotePlaceholder: "örn. çok acılı lütfen",
      variant: "Boy",
      extras: "Ekstralar",
      subtotal: "Ara toplam",
      total: "Toplam",
      placeOrder: "Siparişi ver",
      sending: "Gönderiliyor…",
      orderSent: "Sipariş gönderildi!",
      orderSentDetail: "Garson bilgilendirildi.",
      tableRequired: "Lütfen masanızdaki QR kodu okutun.",
      tableNumber: "Masa",
      remove: "Kaldır",
      close: "Kapat",
      chooseOptions: "Seçenekleri belirle",
      required: "Zorunlu",
    },
    orders: {
      title: "Siparişler",
      empty: "Henüz sipariş yok",
      open: "Açık",
      preparing: "Hazırlanıyor",
      served: "Servis edildi",
      paid: "Ödendi",
      canceled: "İptal",
      all: "Tümü",
      table: "Masa",
      items: "Ürünler",
      total: "Toplam",
      time: "Zaman",
      updateStatus: "Durumu değiştir",
      markPreparing: "Hazırlanıyor",
      markServed: "Servis edildi",
      markPaid: "Ödendi",
      cancel: "İptal et",
      openBill: "Açık hesap",
    },
    menuBuilder: {
      variants: "Varyantlar (boylar)",
      variantsHint: "örn. Küçük, Orta, Büyük — fiyat temel fiyata eklenir",
      addVariant: "Varyant ekle",
      variantName: "Ad (örn. L)",
      variantDelta: "Fark",
      extras: "Ekstralar",
      extrasHint: "örn. Ekstra peynir, Bacon — sabit ek fiyatlar",
      addExtra: "Ekstra ekle",
      extraName: "Ad (örn. ekstra peynir)",
      extraPrice: "Fiyat",
    },
    admin: {
      title: "Yönetici paneli",
      users: "Kullanıcılar",
      changePlan: "Planı değiştir",
      totalUsers: "Kullanıcılar",
      totalRestaurants: "Restoranlar",
    },
  },
};
